import { render, staticRenderFns } from "./EvaluationPF.vue?vue&type=template&id=0b85bef4"
import script from "./EvaluationPF.vue?vue&type=script&lang=js"
export * from "./EvaluationPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports